import React, { memo } from 'react';
import { Input } from '@mui/material';

export const SliderInput = memo(({ value, step, min, max, hideArrows, classes, disabled, onChange, onFocus, onBlur }) => (
    <Input
        className={classes.input}
        value={value}
        margin='dense'
        type='number'
        disabled={disabled}
        onChange={onChange}
        inputProps={{
            step,
            min,
            max,
            className: hideArrows ? classes.hideArrows : undefined
        }}
        onFocus={onFocus}
        onBlur={onBlur}
    />
));